
//actions
// const CHAT_JOIN_REQUEST_START = "chat-join-request-start"
// const CHAT_JOIN_REQUEST_FAIL = "chat-join-request-fail"
// const CHAT_LEAVE_REQUEST = "chat-leave-request"
// const GET_LIVE_CHATS_REQUEST_START = "get-live-chats-request-start"
// const GET_LIVE_CHATS_REQUEST_SUCCESS = "get-live-chats-request-success"
// const GET_LIVE_CHATS_REQUEST_FAIL = "get-live-chats-request-fail"
const NEW_MEETING_RECEIVED = "new-meeting-request"
const LIVE_CHATS_FETCHED = "live-chats-fetched"
const CHAT_CLOSED = "chat-closed"
const CHAT_REMOVED = "chat-removed"
// const MQTT_SUCCESSFULLY_SUBSCRIBED = "mqtt-successfully-subscribed"
const CHAT_JOINED = "chat-joined"
// const INVITED_TO_JOIN = "invited-to-join"
// const END_MEETING = "end-meeting"

const initialState = { liveChats: [], joinedChats: [] }

export default function reducer(state = initialState, action) {
  let newState, liveChats, meetingId, chat, joinedChats, isMeetingPresent

  switch (action.type) {

    case LIVE_CHATS_FETCHED:
      liveChats = action.payload
      newState = Object.assign({}, state, { liveChats })
      return newState

    case CHAT_JOINED:
      chat = action.payload
      joinedChats = state.joinedChats
      joinedChats.push(chat)
      newState = Object.assign({}, state, { joinedChats })
      return newState

    case CHAT_CLOSED:
      meetingId = action.payload
      joinedChats = state.joinedChats
      joinedChats = joinedChats.filter(function (chat) {
        return chat.id !== meetingId
      })
      newState = Object.assign({}, state, { joinedChats })
      return state

    case CHAT_REMOVED:
      meetingId = action.payload
      liveChats = state.liveChats
      liveChats = liveChats.filter(function (chat) {
        return chat.id !== meetingId
      })
      newState = Object.assign({}, state, { liveChats })
      return newState

    case NEW_MEETING_RECEIVED:
      chat = action.payload
      liveChats = state.liveChats
      isMeetingPresent = liveChats.findIndex((element) => {
        return element.id === chat.id
      })
      if (isMeetingPresent < 0) {
        liveChats.push(chat)
      }
      newState = Object.assign({}, state, { liveChats })
      return newState

    default:
      return state
  }
}

// action creators.

export function liveChatsFetched(liveChats) {
  return {
    type: LIVE_CHATS_FETCHED,
    payload: liveChats
  }
}

export function chatClosed(meetingId) {
  return {
    type: CHAT_CLOSED,
    payload: meetingId
  }
}

export function chatRemoved(meetingId) {
  return {
    type: CHAT_REMOVED,
    payload: meetingId
  }
}

export function chatJoined(meetingDetails) {
  return {
    type: CHAT_JOINED,
    payload: meetingDetails
  }
}

export function newMeetingReceived(meetingDetails) {
  return {
    type: NEW_MEETING_RECEIVED,
    payload: meetingDetails
  }
}

export function isMeetingJoined(meetingId) {
  return function (dispatch, getState) {
    let joinedChats = getState().live_chats.joinedChats
    let chatIndex = joinedChats.findIndex((chat) => {
      return chat.meeting_id === meetingId
    })
    if (chatIndex >= 0) {
      return true
    } else {
      return false
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/chats/live_chats_reducer.js